import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../pages/fleet/confirm-modal/confirm-modal.component';
import {map, Observable} from "rxjs";

@Injectable({ providedIn: 'root' })
export class NavigationConfirmService {
  private dialog = inject(MatDialog);

  confirmNavigation(onContinue: () => void, onCancel?: () => void) {
    this.confirmModal('nav-confirm.title', 'nav-confirm.description', onContinue, onCancel);
  }


  /**
   * Open a confirmation modal
   * @param title
   * @param description
   * @param onConfirm
   * @param onCancel
   */
  confirmModal(title: string, description: string, onConfirm: () => void, onCancel?: () => void) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: title,
        description: description
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.continue) {
        onConfirm();
      } else if (onCancel) {
        onCancel();
      }
    });
  }

  /**
   * Open a confirmation modal and return an observable that emits true if the user confirms, false otherwise
   */
  confirmModal$(): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'nav-confirm.title',
        description: 'nav-confirm.description'
      }
    });
    return dialogRef.afterClosed().pipe(
      map(result => !!(result && result.continue))
    );
  }

  /**
   * Open a confirmation modal if there are modifications pending before executing an action
   * @param isModificationPending a boolean function that tells if there are modifications pending
   * @param onContinue the action to execute if there are no modifications pending or if the user confirms
   * @param onCancel the action to execute if the user cancels
   * @private
   */
  beforeActionWithConfirmation(isModificationPending: boolean, onContinue: () => void, onCancel?: () => void) {
    if (isModificationPending) {
      this.confirmNavigation(onContinue, onCancel);
    } else {
      onContinue();
    }
  }
}
